import { API } from "./utils"

export const holds = {
  createHold: ( data) => API.post("/distributions/holds/", data),
  holdsList: (params = null) => API.get("/distributions/holds/", { params }),
  getHold: (type, target_id) => API.get(`/distributions/holds/${type}/${target_id}/`),
  deleteHold: (id) => API.delete(`/distributions/holds/${id}/`),
}